<template>
    <div class="home">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <b-card title="Ik wil graag een klacht melden" tag="article">
                        <b-button to="/klacht" variant="primary" class="mt-2">Klik hier</b-button>
                    </b-card>
                </div>
                <div class="col-md-4">
                    <b-card title="Ik wil een schademelding doen" tag="article">
                        <b-button to="/schade" variant="primary" class="mt-2">Klik hier</b-button>
                    </b-card>
                </div>
                <div class="col-md-4">
                    <b-card title="Ik wil een compliment geven" tag="article">
                        <b-button to="/compliment" variant="primary" class="mt-2">Klik hier</b-button>
                    </b-card>
                </div>
                <div class="col-md-4">
                    <b-card title="Ik ontvang graag een aanbieding" tag="article">
                        <b-button to="/aanbieding" variant="primary" class="mt-2">Klik hier</b-button>
                    </b-card>
                </div>
                <div class="col-md-4">
                    <b-card title="Ik wil graag een onderhoudsvraag melden" tag="article">
                        <b-button to="/onderhoudsvraag" variant="primary" class="mt-2">Klik hier</b-button>
                    </b-card>
                </div>
                <div class="col-md-4">
                    <b-card title="Ik wil graag een mogelijke lead of prospect melden" tag="article">
                        <b-button to="/lead" variant="primary" class="mt-2">Klik hier</b-button>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>

<style lang="scss" scoped>

    .card {
        border: none;
        margin-bottom: 30px;
        min-height: calc(100% - 30px);
    }
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue